function toDisplayDoc(raw, getStableId) {
  if (raw && typeof raw === "object") {
    if (!raw.url) return null;
    return {
      id: raw.id || getStableId(JSON.stringify(raw)),
      name: (raw.name && String(raw.name).trim()) || "Document",
      url: raw.url,
      addedAt: raw.addedAt || null,
      addedBy: raw.addedBy || null,
    };
  }

  if (typeof raw === "string" && raw.trim()) {
    // New named format — a serialized JSON object string.
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === "object" && parsed.url) {
        return {
          id: parsed.id || getStableId(raw),
          name: (parsed.name && String(parsed.name).trim()) || "Document",
          url: parsed.url,
          addedAt: parsed.addedAt || null,
          addedBy: parsed.addedBy || null,
        };
      }
    } catch {
      // fall through to legacy handling
    }
    // Legacy: a plain file URL with no name.
    return {
      id: getStableId(raw),
      name: "Document",
      url: raw,
      addedAt: null,
      addedBy: null,
    };
  }

  return null;
}

/**
 * Normalize the raw `coe` array into FlowDocuments objects the Documents tab can render, each
 * with an id that stays the same across renders. Rows saved before documents had ids get one
 * from `getStableId`; the server never sees it and finds such a row by its file instead.
 */
export function normalizeRplDocuments(rawCoe, getStableId) {
  return (rawCoe || []).map((raw) => toDisplayDoc(raw, getStableId)).filter(Boolean);
}
